<div class="allergen-groups-container">
  <div class="menu-section-tabs" *ngIf="menuSections.length > 0">
    <mat-tab-group [selectedIndex]="getSelectedTabIndex()" (selectedTabChange)="onTabChange($event)">
      <mat-tab *ngFor="let section of menuSections" [label]="section.name"></mat-tab>
    </mat-tab-group>
  </div>
  <div class="list-panel">
    <div class="button-group">
      <button mat-raised-button color="accent" (click)="onClickCreateAllergenGroup()">{{ 'COMMON.CREATE' | translate }}</button>
      <span *ngIf="loading" class="loading-indicator">
        {{ 'COMMON.LOADING' | translate }}
      </span>
      <span *ngIf="error" class="error-message">
        {{ error }}
      </span>
    </div>
    <div class="allergen-group-list">
      <div
        *ngFor="let allergenGroup of allergenGroups"
        class="allergen-group-item"
        (click)="onEditAllergenGroup(allergenGroup.id)"
      >
        <div class="allergen-group-info">
          <div class="allergen-group-preview" *ngIf="!allergenGroup.externalPictureUrl; else imagePreview" [style.background-color]="allergenGroup.backgroundColor || '#ccc'" [style.color]="allergenGroup.textColor || '#000'">
            {{ allergenGroup.name }}
          </div>
          <ng-template #imagePreview>
            <div class="allergen-group-preview allergen-group-preview--image">
              <img [src]="allergenGroup.externalPictureUrl" [alt]="allergenGroup.name">
            </div>
          </ng-template>
          <div class="allergen-group-details">
            <span class="allergen-group-name" [class.has-overrides]="hasOverridesInCurrentSection(allergenGroup.id)">{{ allergenGroup.name }}</span>
            <span class="allergen-group-code" *ngIf="allergenGroup.code">{{ allergenGroup.code }}</span>
            <span class="allergen-group-id">ID: {{ allergenGroup.id }}</span>
            <span class="manually-created-badge" *ngIf="isManuallyCreated(allergenGroup.id)">{{ 'MENU.ALLERGEN_GROUP.MANUALLY_CREATED' | translate }}</span>
          </div>
        </div>
        <div class="allergen-group-actions">
          <button
            *ngIf="isManuallyCreated(allergenGroup.id)"
            mat-icon-button
            color="warn"
            (click)="onDeleteAllergenGroup($event, allergenGroup.id)"
            matTooltip="{{ 'COMMON.DELETE' | translate }}"
          >
            <mat-icon>delete</mat-icon>
          </button>
        </div>
      </div>
      <div *ngIf="!loading && allergenGroups.length === 0" class="empty-state">
        {{ 'MENU.ALLERGEN_GROUP.EMPTY' | translate }}
      </div>
    </div>
  </div>
</div>
<div class="form-panel" *ngIf="formData">
  <app-allergen-group-form
  [allergenGroupId]="formData.allergenGroupId"
  [allergenGroup]="formData.allergenGroup"
  [originalAllergenGroup]="formData.originalAllergenGroup"
  [organization]="formData.organization"
  [menuSectionId]="formData.menuSectionId"
  [menuId]="formData.menuId"
  [allowOverrides]="formData.allowOverrides"
  [allergenGroups]="formData.allergenGroups"
  [menuSections]="formData.menuSections"
  [isVisible]="true"
  (formResult)="onFormResult($event)"
  (closePanel)="onFormClose()"
  ></app-allergen-group-form>
</div>
